export const ERROR500_LOGO_TEST_ID = 'Error500_logo-link-to-home';
export const SVG_SIZES = {
    width: '93.75',
    height: '36',
};
